import DefaultDialog from '@/components/Dialog/DefaultDialog';

export type ContinueWarningDialogProps = {
  onContinue: () => void;
  onCancel: () => void;
};

export default function ContinueWarningDialog({
  onContinue,
  onCancel,
}: ContinueWarningDialogProps) {
  return (
    <DefaultDialog
      variant="warning"
      confirmLabel="Continue"
      title="Continue without saving?"
      message="Closing will lose any unsaved changes. Do you wish to continue?"
      onCancel={onCancel}
      onConfirm={onContinue}
      onClose={onCancel}
    />
  );
}
